import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addGarage } from "../../../actions/admin/garage";
import Alert from "../../layout/Alert";
import AdminPage from "../_components/AdminPage";
import {
  AdminBackLink,
  AdminFormButton,
  AdminFormActions,
} from "../_components/AdminForm";
import ConfirmationModal from "../components/ConfirmationModal";
import SuccessModal from "../components/SuccessModal";
import { ValueList, summarizeFields } from "../components/ChangeSummary";
import useSaveConfirmation from "../components/useSaveConfirmation";
import GarageForm, { GARAGE_LIST, GARAGE_FIELDS } from "./GarageForm";

const AddGarage = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [formData, setFormData] = useState({
    name: "",
    prefecture: [],
    availableVehicleTypes: [],
    lon: "",
    lat: "",
    isActive: true,
    defaultGarage: false,
  });

  const save = useSaveConfirmation({
    save: () => dispatch(addGarage(formData)),
    onDismiss: () => history.push(GARAGE_LIST),
  });

  const onSubmit = (e) => {
    e.preventDefault();
    save.request(summarizeFields(GARAGE_FIELDS, formData));
  };

  return (
    <AdminPage title="Add Garage" actions={<AdminBackLink to={GARAGE_LIST} />}>
      <form onSubmit={onSubmit} className="tw:max-w-[860px]">
        <GarageForm formData={formData} setFormData={setFormData} />

        <AdminFormActions>
          <AdminFormButton type="submit">Add Garage</AdminFormButton>
        </AdminFormActions>
      </form>

      <Alert />

      <ConfirmationModal
        show={!!save.summary}
        title="Create this garage?"
        description="It will be available for dispatch as soon as it is saved."
        confirmLabel="Add Garage"
        busyLabel="Creating..."
        isBusy={save.isSaving}
        error={save.error}
        onCancel={save.cancel}
        onConfirm={save.confirm}
      >
        <ValueList rows={save.summary || []} />
      </ConfirmationModal>

      <SuccessModal
        show={!!save.saved}
        title="Garage created"
        description="It is available for dispatch now. Closing this returns you to the garage list."
        onClose={save.dismiss}
      >
        <ValueList rows={save.saved || []} />
      </SuccessModal>
    </AdminPage>
  );
};

export default AddGarage;
